var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon locker",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 22a10.979 10.979 0 1 0-10.481-7.644L.438 24.437A1.5 1.5 0 0 0 0 25.5v5A1.5 1.5 0 0 0 1.5 32h5A1.5 1.5 0 0 0 8 30.5V28h2.5a1.5 1.5 0 0 0 1.5-1.5V24h2.5a1.5 1.5 0 0 0 1.063-.437l2.081-2.081A11.026 11.026 0 0 0 21 22zm2.5-16A2.5 2.5 0 1 1 21 8.5 2.5 2.5 0 0 1 23.5 6z",
    style: {
      fill: "#2e3540"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockerIcon);
export default __webpack_public_path__ + "static/media/locker-icon.a88365d292ca395f3745d6086c99e3e7.svg";
export { ForwardRef as ReactComponent };